import { FaseTratamentoEnum } from '../enum/fase-tratamento';

export class FormularioOrtodontia {

    constructor(
    	public tipoFormulario?: number,
    	
		//passo 1
        public queixaPaciente?: string,
        public possuiAparelho?: boolean,
        public tempoAparelho?: number,
        public aparelho?: string,
        public aparelhoFixoEstetico?: boolean,
        public faseDoTratamento?: FaseTratamentoEnum,
		public classificacaoMolarDireito?: number,
        public classificacaoMolarEsquerdo?: number,
        public classificacaoCaninoDireito?: number,
		public classificacaoCaninoEsquerdo?: number,
		
		// passo 2
		public biprotrusao?: boolean,
		public apinhamento?: boolean,
		public txtApinhamento?: string,
		public diastemas?: boolean,
		public txtDiastemas?: string,
		public mordidaAberta?: boolean,
		public txtMordidaAberta?: string,
		public mordidaCruzada?: boolean,
		public txtMordidaCruzada?: string,
		public mordidaProfunda?: boolean,
		public sobresaliencia?: boolean,
		public aparatologia?: string,
		public tecnicaUtilizada?: string,
		public prognostico?: string,
		public tempoConclusao?: number,
		public nomeResponsavel?: string,

        // passo 2 planejamento
        public alinhamentoNivelamento?: boolean,
	    public avancoMandibular?: boolean,
	    public expansaoSuperior?: boolean,
	    public expansaoInferior?: boolean,
	    public disjuncaoERM?: boolean,
	    public disjuncaoERMProtracaoMandibular?: boolean,
	    public verticalizacao?: boolean,
	    public txtVerticalizacao?: string,
	    public exodontia?: boolean,
	    public txtExodontia?: string,
	    public distralizacaoMolarSuperior?: boolean,
	    public distralizacaoMolarInferior?: boolean,
	    public extrusao?: boolean,
	    public txtExtrusao?: string,
	    public intrusao?: boolean,
	    public txtIntrusao?: string,
	    public fechamentoDiastemas?: boolean,
	    public txtFechamentoDiastemas?: string,
	    public desgasteInterproximal?: boolean,
	    public txtDesgasteInterproximal?: string,
	    public elasticoClasse2?: boolean,
	    public elasticoClasse3?: boolean,
	    public acertoLinhasMedianas?: boolean,
	    public planejamentoOutros?: boolean,
	    public txtPlanejamentoOutros?: string,
	    public diagnosticoOutros?: boolean,
	    public txtDiagnosticoOutros?: string,
	    
	    //prorrogacao
	    public justificativaProrrogacao?: string,
	    public alteracoesOcorridas?: string
	    
    ){}

    
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/formulario-ortodontia.ts